import { FC, useEffect, useMemo, useRef, useState } from 'react'
import {
  fetchData,
  findMenuWithParent,
  formatNumber,
  getEncodedCookie,
  getEncryptedRoute,
  toasterrormsg,
} from '../../../../reusable'
import { KTIcon } from '../../../../_metronic/helpers'
import { ToastContainer } from 'react-toastify'
import DataTable from 'react-data-table-component'
import moment from 'moment'
import { Link, useLocation } from 'react-router-dom'
import Select, { CSSObjectWithLabel } from 'react-select'
import { Tr } from '../../../../_metronic/i18n/Tr'
import { useMenuContext } from '../../contexts/MenuContext'

interface Vendor {
  vendorName: string
  vendorId: number
}

interface Row {
  vendors: Vendor[]
}

const ViewAdminVendorPaymetDetail: FC = () => {
  let t = Tr()
  const { fullMenu } = useMenuContext()

  const location = useLocation()
  const categoryId = (location.state as any)?.categoryId || ''
  const previousSelectedMonth = (location.state as any)?.previousSelectedMonth || ''
  const previousSelectedYear = (location.state as any)?.previousSelectedYear || ''

  const [paymentDetailList, setPaymentDetailList] = useState([])
  const [orgPaymentDetailList, setOrgPaymentDetailList] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState('')
  const [totalRecords, setTotalRecords] = useState('') as any
  const [limit, setLimit] = useState(10)
  const [offset, setOffset] = useState(0)
  const [totalFinalAmount, setTotalFinalAmount] = useState('')
  const [subTotal, setSubTotal] = useState('')
  const [totalInsayrServiceFee, setTotalInsayrServiceFee] = useState('')
  const [totalPercentagePaid, setTotalPercentagePaid] = useState('')
  const [selectedStatus, setSelectedStatus] = useState('') as any
  const [totalVendorRevenue, setTotalVendorRevenue] = useState('') as any

  const [statusList] = useState([
    { value: '0', label: 'pending' },
    { value: '1', label: 'Approved' },
    { value: '3', label: 'Cancelled' },
    { value: '4', label: 'Completed' },
  ]) as any

  const currentMonth = new Date().getMonth() + 1
  const currentYear = new Date().getFullYear()
  const yearList = Array.from({ length: currentYear - 2020 + 1 }, (_, i) => ({
    value: (currentYear - i).toString(),
    label: (currentYear - i).toString(),
  }))

  let month = previousSelectedMonth != '' ? previousSelectedMonth : currentMonth
  let year = previousSelectedYear != '' ? previousSelectedYear : currentYear
  const [selectedMonth, setSelectedMonth] = useState(month) as any
  const [selectedYear, setSelectedYear] = useState(year) as any

  const [monthList] = useState([
    { value: '1', label: 'January' },
    { value: '2', label: 'February' },
    { value: '3', label: 'March' },
    { value: '4', label: 'April' },
    { value: '5', label: 'May' },
    { value: '6', label: 'June' },
    { value: '7', label: 'July' },
    { value: '8', label: 'August' },
    { value: '9', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
  ]) as any

  const getMonthStartAndEndDates = (year: number, month: number) => {
    if (!year || !month) {
      return {
        startDate: '',
        endDate: '',
      }
    }
    const startDate = new Date(year, month - 1, 1) // Start of the month
    const endDate = new Date(year, month, 0) // Last day of the month

    // Format dates in 'YYYY-MM-DD' to avoid timezone-related issues
    const formattedStartDate = `${String(startDate.getDate()).padStart(2, '0')}-${String(
      startDate.getMonth() + 1
    ).padStart(2, '0')}-${startDate.getFullYear()}`
    const formattedEndDate = `${String(endDate.getDate()).padStart(2, '0')}-${String(
      endDate.getMonth() + 1
    ).padStart(2, '0')}-${endDate.getFullYear()}`

    return {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    }
  }

  const clearFields = () => {
    setSelectedYear(currentYear)
    setSelectedMonth(currentMonth)
    setSelectedStatus('')
    paymentDetailListApiCall('ALL', currentYear, currentMonth)
    delatiledRevenueReportTotalApiCall('ALL' , currentYear , currentMonth)
  }

  //   Payment detail list api call
  const paymentDetailListApiCall = async (
    status: any,
    year = selectedYear,
    month = selectedMonth,
    limit1?: any,
    offset1?: any
  ) => {
    const { startDate, endDate } = getMonthStartAndEndDates(year, month)

    var param: any = ''
    if (status == 'ALL') {
      param = {
        categoryId: categoryId,
        fromDate: startDate,
        toDate: endDate,
        limit: limit1,
        offset: offset1,
      }
    } else {
      if (
        selectedStatus.value != null &&
        selectedStatus.value != undefined &&
        selectedStatus.value != ''
      ) {
        param = {
          categoryId: categoryId,
          fromDate: startDate,
          toDate: endDate,
          status: selectedStatus.value,
          limit: limit1,
          offset: offset1,
        }
      } else {
        param = {
          categoryId: categoryId,
          fromDate: startDate,
          toDate: endDate,
          limit: limit1,
          offset: offset1,
        }
      }
    }

    var res = await fetchData('admin/detailedrevenuereports', param)

    if (res.status == '200') {
      var data = res.data.data
      setPaymentDetailList(data)
      setTotalRecords(res.data.totalRecord)
      setOrgPaymentDetailList(data)
    } else {
      toasterrormsg(res.message)
    }
  }

  const delatiledRevenueReportTotalApiCall = async (
    status: any,
    year = selectedYear,
    month = selectedMonth
  ) => {
    const { startDate, endDate } = getMonthStartAndEndDates(year, month)

    var param: any = ''
    if (status == 'ALL') {
      param = {
        categoryId: categoryId,
        fromDate: startDate,
        toDate: endDate,
      }
    } else {
      if (
        selectedStatus.value != null &&
        selectedStatus.value != undefined &&
        selectedStatus.value != ''
      ) {
        param = {
          categoryId: categoryId,
          fromDate: startDate,
          toDate: endDate,
          status: selectedStatus.value,
        }
      } else {
        param = {
          categoryId: categoryId,
          fromDate: startDate,
          toDate: endDate,
        }
      }
    }

    var res = await fetchData('admin/detailedrevenuereportstotal', param)

    if (res.status == '200') {
      var data = res.data

      setTotalFinalAmount(data.totalAmount != '' ? data.totalAmount : '')
      setSubTotal(data.subTotal != '' ? data.subTotal : '')
      setTotalInsayrServiceFee(data.insayrServiceFee != '' ? data.insayrServiceFee : '')
      setTotalPercentagePaid(data.percentagePaid)
      setTotalVendorRevenue(data.vendorServiceFee != '' ? data.vendorServiceFee : '')
    } else {
      toasterrormsg(res.message)
    }
  }

  // search Coupon
  const paymentDetailSearch = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    if (text == '' || text == null || text == undefined) {
      setPaymentDetailList(orgPaymentDetailList)
    } else {
      var tmp: any = orgPaymentDetailList.filter((item: any) => {
        return (
          (item.bookingCode != null &&
            item.bookingCode != '' &&
            String(item.bookingCode).includes(text)) ||
          (item.vendors != null && item.vendors != '' && String(item.vendors).includes(text)) ||
          (item.propertyType != null &&
            item.propertyType != '' &&
            String(item.propertyType).toLowerCase().includes(text.toLowerCase())) ||
          (item.totalAmount != null &&
            item.totalAmount != '' &&
            String(item.totalAmount).toLowerCase().includes(text.toLowerCase())) ||
          (item.insayrServiceFee != null &&
            item.insayrServiceFee != '' &&
            String(item.insayrServiceFee).toLowerCase().includes(text.toLowerCase())) ||
          (item.vendorRevenue != null &&
            item.vendorRevenue != '' &&
            String(item.vendorRevenue).toLowerCase().includes(text.toLowerCase())) ||
          (item.toDate != null &&
            item.toDate != '' &&
            String(item.toDate).toLowerCase().includes(text.toLowerCase())) ||
          (item.vendors != null &&
            item.vendors != '' &&
            String(item.vendors).toLowerCase().includes(text.toLowerCase())) ||
          (item.status != null &&
            item.status != '' &&
            String(item.status).toLowerCase().includes(text.toLowerCase())) ||
          (item.originalAmount != null &&
            item.originalAmount != '' &&
            String(item.originalAmount).toLowerCase().includes(text.toLowerCase()))
        )
      })

      setPaymentDetailList(tmp)
    }
  }

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.customSearch(e, 1)
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])

    return (
      <div className=' d-flex justify-content-between w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 '>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search Payment Details')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
      </div>
    )
  }
  const formatDate2 = (date: any) => {
    return moment(date).format('DD-MM-YYYY')
  }
  // Define your DataTable columns
  let result;
  const getBookingRoute = () => {
    if (categoryId == '1') {
      result = findMenuWithParent(fullMenu, "../viewhotelbooking/");
      const menuId = result?.menu?.menuId
      return getEncryptedRoute('../viewhotelbookingdetails', { menuId: menuId })
    } else if (categoryId == '4') {
      result = findMenuWithParent(fullMenu, "../viewspacerentalbooking/");
      const menuId = result?.menu?.menuId
      return getEncryptedRoute('../viewspacebookingdetails', { menuId: menuId })
    } else if (categoryId == '5') {
        result = findMenuWithParent(fullMenu, '../viewtourbooking/');
      const menuId = result?.menu?.menuId
      return getEncryptedRoute('../viewtourbookingdetails', { menuId: menuId })
    } else if (categoryId == '7') {
         result = findMenuWithParent(fullMenu, '../viewcarrentalbookings/');
      const menuId = result?.menu?.menuId
      return getEncryptedRoute('../viewcarbookingdetails', { menuId: menuId })
    }
    return '' // default fallback
  }
  const column = useMemo(
    () => [
      {
        name: t('Booking Id'),
        cell: (row: any) => (
          <div className='my-3'>
            {row.bookingCode != 'totalRecords' ? (
              <>
                <div className='fw-bold fs-5 text-primary under text-decoration-underline cursor-pointer'>
                  <Link
                    to={getBookingRoute()}
                    state={{
                      bookingId: row.bookingId,
                    }}
                  >
                    #{row.bookingCode || ''}
                  </Link>{' '}
                </div>{' '}
              </>
            ) : (
              <div className='fw-bold'> {totalRecords}</div>
            )}
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => Number(row.bookingCode),
        width: '200px',
      },
      {
        name:
          categoryId == '5'
            ? t('Tour Date')
            : categoryId == '4'
              ? t('Renting Date')
              : categoryId == '7'
                ? t('Drop Off Date')
                : t('Check Out Date'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.categoryId != 5 && row.toDate != '' && row.toDate != 'Total'
                ? formatDate2(row.toDate)
                : ''}{' '}
              {row.toDate == 'Total' ? 'Total' : ''}{' '}
              {row.categoryId == 5 && row.fromDate != '' ? formatDate2(row.fromDate) : ''}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.toDate),
        sortFunction: (rowA: any, rowB: any) => {
          const dateA = rowA.toDate ? new Date(rowA.toDate) : null
          const dateB = rowB.toDate ? new Date(rowB.toDate) : null

          // Handle the case where one or both dates are empty
          if (!dateA && !dateB) return 0 // Both dates are empty
          if (!dateA) return 1 // Empty dates go to the end (you can change this to -1 if you want empty first)
          if (!dateB) return -1

          // Sorting logic: Ascending or Descending based on the click
          if (dateA < dateB) return -1 // Ascending
          if (dateA > dateB) return 1 // Descending
          return 0
        },
        filter: true,
        width: '200px',
      },

      {
        name:
          categoryId == '1'
            ? t('Accommodation Name')
            : categoryId == '4'
              ? t('Space Name')
              : categoryId == '5'
                ? t('Agency Name')
                : categoryId == '7'
                  ? t('Supplier Name')
                  : '',
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.propertyName != '' ? row.propertyName : '-'}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.propertyName),
        filter: true,
        width: '200px',
      },
      {
        name: t('Service Type'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.categoryId != 'NA'
                ? categoryId == 1
                  ? 'Accommodation'
                  : categoryId == 4
                    ? 'Space Rental'
                    : categoryId == 5
                      ? 'Tour Packages'
                      : categoryId == 7
                        ? 'Car Rental'
                        : '-'
                : '-'}
            </div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => String(row.categoryId),
        width: '200px',
      },

      {
        name:
          categoryId == '4'
            ? t('Space Type')
            : categoryId == '5'
              ? t('Tour Type')
              : categoryId == '7'
                ? t('Car Type')
                : t('Property Type'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.propertyType != '' ? row.propertyType : '-'}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.propertyType),
        filter: true,
        width: '200px',
      },
      {
        name: t('Booking Status'),
        cell: (row: any) => (
          <div className='my-3'>
            {row.status == 0 ? (
              <span className='btn btn-warning mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                {t('Pending')}
              </span>
            ) : row.status == 1 ? (
              <span className='btn btn-success mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                {t('Approved')}
              </span>
            ) : row.status == 2 ? (
              <span className='btn btn-light-danger mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                {t('Rejected')}
              </span>
            ) : row.status == 3 ? (
              <>
                <span className='btn btn-danger mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                  {t('Cancelled')}
                </span>
                <div className='text-center mt-2'>
                  {' '}
                  <span className='fw-bold fs-6'>
                    (
                    {row.cancellationCharge != ''
                      ? row.cancellationCharge + "% " + t('Charges')
                      : "0% " + 'Charges'}
                    )
                  </span>
                </div>
              </>
            ) : row.status == 4 ? (
              <span className='btn btn-success mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                {t('Completed')}
              </span>
            ) : (
              '-'
            )}
          </div>
        ),
        sortable: true,
        filter: true,
        width: '180px',
        selector: (row: any) => String(row.status),
      },
      {
        name: t('Original Amount'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.subTotal != '' ? formatNumber(row.subTotal) : '0 UZS'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.subTotal),
        filter: true,
        width: '170px',
      },
      {
        name: t('Final Amount'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.totalAmount != '' ? formatNumber(parseFloat(row.totalAmount)) : '0 UZS'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.totalAmount),
        filter: true,
        width: '170px',
      },
      {
        name: t('Insayr Service Fee'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.insayrServiceFee != '' &&
                row.insayrServiceFee != undefined &&
                row.insayrServiceFee != null
                ? formatNumber(parseFloat(row.insayrServiceFee))
                : '0 UZS'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.insayrServiceFee),
        filter: true,
      },
      {
        name: t('Vendor Revenue'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.vendorRevenue != '' ? formatNumber(parseFloat(row.vendorRevenue)) : '0 UZS'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.vendorRevenue),
        filter: true,
        width: '200px',
      },
      {
        name: t('Vendor Payment Status'),
        cell: (row: any) => (
          <div className='my-3'>
            <label className='form-check form-switch form-check-custom form-check-success form-check-solid '>
              {row.PaymentStatus == 'Pending' ? (
                <span className='badge badge-warning mx-2'>{t('Pending')}</span>
              ) : row.PaymentStatus == 'Paid' ? (
                <span className='badge badge-success mx-2'>{t('Paid')}</span>
              ) : !isNaN(row.PaymentStatus) ? (
                <div className='fw-bold'>{row.PaymentStatus + '% Paid'}</div>
              ) : (
                '-'
              )}
            </label>
          </div>
        ),
        sortable: true,
        filter: true,
        width: '200px',
        selector: (row: any) => Number(row.mainStatus),
      },
    ],
    [selectedMonth, selectedYear, paymentDetailList, t]
  )

  useEffect(() => {
    paymentDetailListApiCall('ALL')
    delatiledRevenueReportTotalApiCall('ALL')
    document.title = 'Insayr | View Revenue Breakdown Details'
  }, [])

  const handlePageChange = (newPage: number) => {
    const totalPages = Math.ceil(totalRecords / limit) // Total pages based on API data only
    const newOffset = (newPage - 1) * limit
    setOffset(newOffset)
    paymentDetailListApiCall('ALL', selectedYear, selectedMonth, limit, newOffset)
  }

  const handleRowsPerPageChange = (newRowsPerPage: number) => {
    setLimit(newRowsPerPage)
    paymentDetailListApiCall('ALL', selectedYear, selectedMonth, newRowsPerPage, offset)
  }

  const customRow = {
    bookingCode: 'totalRecords',
    toDate: 'Total',
    propertyName: '',
    categoryId: 'NA',
    propertyType: '',
    status: 'NA',
    subTotal: subTotal,
    totalAmount: totalFinalAmount,
    insayrServiceFee: totalInsayrServiceFee,
    vendorRevenue: totalVendorRevenue,
    PaymentStatus: totalPercentagePaid,
  }

  const dataWithCustomRow = useMemo(() => {
    return [...paymentDetailList, customRow]
  }, [paymentDetailList, totalFinalAmount, totalInsayrServiceFee, totalPercentagePaid])

  return (
    <>
      <div className='container'>
        <div className='justify-content-center d-flex flex-wrap gap-5 mb-6'>
          <div className='filters'>
            <label htmlFor='selectedMonth' className='fs-4 form-label'>
              {t('Select Month')}
            </label>
            <Select
              name='selectVendorMonth'
              id='selectedMonth'
              placeholder={t('Select Month')}
              isSearchable={true}
              options={monthList}
              value={monthList.find((option: any) => option.value == selectedMonth) || null}
              onChange={(e: any) => {
                setSelectedMonth(e.value)
              }}
            />
          </div>
          <div className='filters'>
            <label htmlFor='selectedYear' className='fs-4 form-label'>
              {t('Select Year')}
            </label>
            <Select
              name='selectVendorYear'
              id='selectedYear'
              placeholder={t('Select Year')}
              isSearchable={true}
              options={yearList}
              value={yearList.find((option: any) => option.value == selectedYear) || null}
              onChange={(e: any) => {
                setSelectedYear(e.value)
              }}
            />
          </div>
          <div className='filters'>
            <label htmlFor='SelectStatus' className='fs-4 form-label'>
              {t('Select Status')}
            </label>
            <Select
              name='SelectStatus'
              id='SelectStatus'
              placeholder={t('Select Status')}
              isSearchable={true}
              options={statusList}
              value={selectedStatus}
              onChange={(e: any) => setSelectedStatus(e)}
              styles={{
                container: (provided : CSSObjectWithLabel) => ({ ...provided, width: '100%' }),
                control: (provided : CSSObjectWithLabel) => ({ ...provided, minHeight: 43 }),
              }}
            />
          </div>
        </div>
      </div>

      <div className='d-flex justify-content-center mb-5'>
        <div className='col-md-2 mb-3 d-flex align-items-end'>
          <button
            className='btn btn-primary mx-1'
            onClick={() => {
              paymentDetailListApiCall('')
              delatiledRevenueReportTotalApiCall('')
            }}
          >
            {t('Apply')}
          </button>
          <button className='btn btn-danger mx-1' onClick={() => clearFields()}>
            {t('Clear')}
          </button>
        </div>
      </div>
      <ToastContainer />

      <>
        <DataTable
          columns={column}
          data={paymentDetailList.length > 0 ? dataWithCustomRow : paymentDetailList}
          pagination
          paginationServer={true}
          subHeader={true}
          subHeaderComponent={
            <CustomHeader search={searchTerm} isfoc={focus} customSearch={paymentDetailSearch} />
          }
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          paginationTotalRows={totalRecords}
          paginationPerPage={limit}
          paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
          paginationComponentOptions={{
            rowsPerPageText: t('Rows Per Page'),
          }}
        />
      </>
    </>
  )
}

export { ViewAdminVendorPaymetDetail }
